
import { useState, useEffect } from 'react';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Save, Loader2 } from 'lucide-react';

interface NoteTabProps {
  commentId: string;
}

const NoteTab = ({ commentId }: NoteTabProps) => {
  const [note, setNote] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  useEffect(() => {
    // Simuler le chargement d'une note existante
    const savedNote = localStorage.getItem(`note_${commentId}`);
    if (savedNote) {
      setNote(savedNote);
    }
  }, [commentId]);

  const handleSaveNote = () => {
    setIsSaving(true);
    
    // Simuler un délai de sauvegarde
    setTimeout(() => {
      localStorage.setItem(`note_${commentId}`, note);
      setIsSaving(false);
      setIsSaved(true);
      
      // Réinitialiser le message de succès après 3 secondes
      setTimeout(() => {
        setIsSaved(false);
      }, 3000);
    }, 500);
  };

  return (
    <div className="space-y-4">
      <div>
        <label htmlFor="note" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Note privée (visible uniquement par l'équipe)
        </label>
        <Textarea
          id="note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Ajouter une note à propos de ce commentaire..."
          className="min-h-[150px] bg-white dark:bg-gray-800/90 border-gray-300 dark:border-gray-700 transition-colors"
        />
      </div>
      
      <div className="flex items-center justify-between">
        {isSaved && (
          <span className="text-green-600 dark:text-green-400 text-sm">
            Note sauvegardée avec succès !
          </span>
        )}
        
        <div className="ml-auto">
          <Button
            onClick={handleSaveNote}
            disabled={isSaving}
            className="bg-custom-primary hover:bg-custom-dark text-white dark:bg-custom-secondaryLight dark:text-gray-900 dark:hover:bg-custom-secondaryLight/90"
          >
            {isSaving ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Sauvegarde...
              </>
            ) : (
              <>
                <Save className="h-4 w-4 mr-2" />
                Sauvegarder
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoteTab;
